import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ShareButtons } from "@/components/site/ShareButtons";
import { CommentSection } from "@/components/site/CommentSection";
import { ArrowLeft } from "lucide-react";

export default function StoryDetail() {
  const { id } = useParams();
  const [s, setS] = useState(null);
  useEffect(() => { api.get(`/stories/${id}`).then(r => setS(r.data)).catch(() => setS(null)); }, [id]);
  if (!s) return <div className="max-w-3xl mx-auto px-4 py-32 text-[#A0AABF]">Povestea nu a fost găsită.</div>;
  return (
    <div data-testid="page-story-detail" className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
      <Link to="/comunitate" className="inline-flex items-center gap-2 text-[#D4A63D] text-sm mb-6"><ArrowLeft className="w-4 h-4" /> Comunitate</Link>
      <div className="text-[10px] uppercase tracking-[0.3em] text-[#D4A63D] mb-3">{s.county} · {s.relation}</div>
      <h1 className="font-display text-4xl md:text-5xl text-[#F8F8F4] leading-tight">{s.title}</h1>
      <div className="mt-4 text-sm text-[#A0AABF]">de {s.author_name} · {new Date(s.published_at || s.created_at).toLocaleDateString("ro-RO")}</div>
      <div className="mt-10 font-quote text-xl md:text-2xl text-[#F8F8F4] leading-relaxed whitespace-pre-line">{s.body}</div>
      <div className="my-12 gold-divider" />
      <div className="cinematic-card rounded-lg p-6 flex items-center justify-between flex-wrap gap-4">
        <p className="text-sm text-[#A0AABF]">Distribuie această poveste — fiecare share ajunge la cineva care suferă în tăcere.</p>
        <ShareButtons title={s.title} compact />
      </div>
      <CommentSection targetType="story" targetId={s.story_id} />
    </div>
  );
}
